import { useCallback, useEffect, useRef } from 'react';
import { useResourceContext, useGetIdentity, useGetRecordId, } from 'react-admin';
import { useLock, useUnlock } from '../dataProvider';
/**
 * Get a callback to lock a record and a mutation state
 *
 * @example // get resource, record id and locker identity from context
 * const LockButton = () => {
 *   const [doLock, lockMutation] = useLockOnCall();
 *   return (
 *     <button onClick={() => doLock()} disabled={lockMutation.isLoading}>
 *       Lock
 *     </button>
 *   );
 * };
 *
 * @example // pass resource, record id and locker identity as options
 * const LockButton = ({ resource, id, identity }) => {
 *   const [doLock, lockMutation] = useLockOnCall({ resource, id, identity });
 *   return (
 *     <button onClick={() => doLock()} disabled={lockMutation.isLoading}>
 *       Lock
 *     </button>
 *   );
 * };
 */
export var useLockOnCall = function (params) {
    if (params === void 0) { params = {}; }
    var identityProp = params.identity, paramsResource = params.resource, paramsId = params.id, meta = params.meta, lockMutationOptions = params.lockMutationOptions, unlockMutationOptions = params.unlockMutationOptions;
    var resource = useResourceContext({ resource: paramsResource });
    var _a = useGetIdentity(), identityFromAuthProvider = _a.identity, isGetIdentityLoading = _a.isLoading;
    var identity = identityProp !== null && identityProp !== void 0 ? identityProp : identityFromAuthProvider === null || identityFromAuthProvider === void 0 ? void 0 : identityFromAuthProvider.id;
    var id = useGetRecordId(paramsId);
    var _b = useLock(undefined, undefined, lockMutationOptions), lock = _b[0], lockMutation = _b[1];
    var unlock = useUnlock(undefined, undefined, unlockMutationOptions)[0];
    var hasLock = useRef(false);
    var doLock = useCallback(function () {
        return new Promise(function (resolve, reject) {
            if (isGetIdentityLoading || !identity) {
                reject(new Error('The AuthProvider must have a getIdentity function for locks to work or you must provide the identity option'));
            }
            lock(resource, { identity: identity, id: id, meta: meta }, {
                onSuccess: function (result) {
                    hasLock.current = true;
                    resolve(result);
                },
                onError: reject,
            });
        });
    }, [resource, id, meta, identity, isGetIdentityLoading, lock]);
    useEffect(function () {
        return function () {
            if (hasLock.current) {
                unlock(resource, { identity: identity, id: id, meta: meta });
            }
        };
    }, [resource, id, meta, identity, isGetIdentityLoading, unlock]);
    return [doLock, lockMutation];
};
